import { useParams } from "react-router-dom";
import { useRef, useState } from "react";
import {
    Typography,
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BackIcon from "../../../../../components/back/back";
import { AcerFamilies } from "./AcerDesktop";
import palmsIcon from "../../../../../assets/palms/palm-animated.jpg";

export default function AcerDetailsPage() {
    const { name } = useParams();
    const acer = AcerFamilies.find(
        (a) => a.name.toLowerCase().replace(/\s+/g, "-") === name?.toLowerCase()
    );

    const [selectedLanguage, setSelectedLanguage] = useState<"en" | "ar">("en");
    const [open, setOpen] = useState(false);
    const [selectedType, setSelectedType] = useState<any | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleOpen = (type: any) => {
        setSelectedType(type);
        setCurrentIndex(0);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedType(null);
    };

    const scrollToIndex = (index: number) => {
        if (scrollContainerRef.current) {
            const selectedThumbnail = scrollContainerRef.current.children[index] as HTMLDivElement;
            if (selectedThumbnail) {
                selectedThumbnail.scrollIntoView({ behavior: "smooth", inline: "center" });
            }
        }
    };

    const nextImage = () => {
        if (!selectedType?.variations) return;
        const newIndex = (currentIndex + 1) % selectedType.variations.length;
        setCurrentIndex(newIndex);
        scrollToIndex(newIndex);
    };

    const prevImage = () => {
        if (!selectedType?.variations) return;
        const newIndex = (currentIndex - 1 + selectedType.variations.length) % selectedType.variations.length;
        setCurrentIndex(newIndex);
        scrollToIndex(newIndex);
    };

    const handleTranslate = () => {
        setSelectedLanguage(selectedLanguage === "en" ? "ar" : "en");
    };

    if (!acer) return <p>Acer not found</p>;

    return (
        <div className="ficus-container">
            <BackIcon />
            <Box
                sx={{
                    textAlign: "center",
                    // mt: { xs: "5rem", md: "7rem" },
                    px: "1rem",
                }}
            >
                <div className="title-with-flowers title-overlay">
                    <span className="flower">🍁</span>
                    <h1>{acer.name} Collection</h1>
                    <span className="flower">🍁</span>
                </div>

                <Typography sx={{ mt: 2, fontSize: { xs: "1rem", md: "1.2rem" }, fontFamily: "Century Gothic" }}>
                    {acer.description[selectedLanguage]}
                </Typography>

                <div
                    className="gallery"
                    style={{
                        marginTop: "3rem",
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        gap: "2rem",
                    }}
                >
                    {acer.types.map((type, idx) => (
                        <div
                            key={idx}
                            onClick={() => handleOpen(type)}
                            className="ficus-shape-card bg-white p-6 rounded-xl shadow-lg hover:scale-105 cursor-pointer"
                            style={{ width: "250px" }}
                        >
                            <img
                                src={type.variations[0].src}
                                alt={type.typeName}
                                className="w-full h-48 object-cover rounded-md"
                            />
                            <Typography fontWeight="bold" mt={1} sx={{ fontFamily: "Century Gothic" }}>
                                {type.typeName}
                            </Typography>
                        </div>
                    ))}
                </div>

                <Box
                    sx={{
                        mt: 6,
                        textAlign: selectedLanguage === "ar" ? "right" : "left",
                        direction: selectedLanguage === "ar" ? "rtl" : "ltr",
                        maxWidth: "800px",
                        mx: "auto",
                    }}
                >
                    <Typography sx={{ fontFamily: "Century Gothic" }}>
                        <strong>{selectedLanguage === "ar" ? "الوصف" : "Description"}:</strong>
                        <br />
                        <span
                            dangerouslySetInnerHTML={{
                                __html: acer.specifications[selectedLanguage],
                            }}
                        />
                    </Typography>

                    <Typography mt={3} sx={{ fontFamily: "Century Gothic" }}>
                        <strong>
                            {selectedLanguage === "ar"
                                ? "الصيانة والعناية"
                                : "Maintenance & Care"}
                            :
                        </strong>
                        <br />
                        <span
                            dangerouslySetInnerHTML={{
                                __html: acer.Maintenance[selectedLanguage],
                            }}
                        />
                    </Typography>

                    <Button
                        onClick={handleTranslate}
                        sx={{
                            mt: 3,
                            fontSize: "0.9rem",
                            color: "#40826D",
                            textDecoration: "underline",
                            opacity: 0.7,
                        }}
                    >
                        {selectedLanguage === "en" ? "ترجمة للعربية" : "Translate to English"}
                    </Button>
                </Box>
            </Box>

            {/* Dialog for selected type */}
            <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                        <Typography variant="h6" className="gallery-title-name" ml={2} sx={{ fontFamily: "Century Gothic", marginLeft: "0px" }}>
                            {selectedType?.typeName}
                        </Typography>
                    </div>
                    <IconButton onClick={handleClose} style={{ position: "absolute", right: 10, top: 8, backgroundColor: "#AFE1AF" }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <div className="horizontal-gallery" style={{ position: "relative", overflow: "hidden" }}>
                        <button className="nav-button left" onClick={prevImage}>‹</button>

                        <div
                            className="scroll-container"
                            ref={scrollContainerRef}
                            style={{
                                display: "flex",
                                overflowX: "auto",
                                gap: "2rem",
                                padding: "1rem 2rem",
                                scrollBehavior: "smooth",
                            }}
                        >
                            {selectedType?.variations.map((v: any, index: number) => (
                                <div
                                    className="image-container"
                                    key={index}
                                    style={{
                                        minWidth: "400px",
                                        cursor: "pointer",

                                        borderRadius: "10px",
                                        padding: "0.5rem",
                                    }}
                                    onClick={() => {
                                        setCurrentIndex(index);
                                        scrollToIndex(index);
                                    }}
                                >
                                    <img
                                        src={v.src}
                                        alt={`Gallery ${index}`}
                                        className="gallery-thumbnail"
                                        style={{
                                            width: "300px",
                                            height: "300px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                        }}
                                    />
                                    <div style={{ textAlign: "center", marginTop: "8px" }}>
                                        <Typography variant="body2" fontWeight="bold">{v.name}</Typography>
                                        <Typography variant="body2" color='#2E8B57'>Color: {v.color}</Typography>
                                        <Typography variant="body2" color="#CC5500">Size: {v.size}</Typography>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <button className="nav-button right" onClick={nextImage}>›</button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
